
import React from 'react';
import Filters from '../Filter';
import FilterInput from '../Filter/components/FilterInput';
import { translate } from '../../services/translate';
import EquipmentsDropdown from './EquipmentsDropdown';
import ActingBodiesUnitsDropdown from './ActingBodyUnitDropdown';
import SkillsDropdown from './SkillsDropdown';
import FilterCheckBox from '../Filter/components/FilterCheckBox';

interface Props {
    textFilter: string;
    setTextFilter: (value: string) => void;
    actingBodyId: number;
    equipmentFilterList: number[];
    setEquipmentFilterList: React.Dispatch<React.SetStateAction<number[]>>;
    skillFilterList: number[];
    setSkillFilterList: React.Dispatch<React.SetStateAction<number[]>>;
    actingBodyUnitIds: number[];
    setActingBodyUnitIds: React.Dispatch<React.SetStateAction<number[]>>;
    viewAllFilter: boolean;
    setViewAllFilter: React.Dispatch<React.SetStateAction<boolean>>;
    handleFilter: () => void;
}


export function OccurrenceDetailFilter({
    textFilter,
    setTextFilter,
    actingBodyId,
    equipmentFilterList,
    setEquipmentFilterList,
    skillFilterList,
    setSkillFilterList,
    viewAllFilter,
    setViewAllFilter,
    actingBodyUnitIds,
    setActingBodyUnitIds,
    handleFilter,
}: Props) {
    const handleCleanFilter = () => {
        setTextFilter('');
        setEquipmentFilterList([]);
        setSkillFilterList([]);
        setViewAllFilter(true);
        setActingBodyUnitIds([]);
    };

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <FilterInput
                label={translate('typeToSearch')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />

            <ActingBodiesUnitsDropdown
                value={actingBodyUnitIds}
                setValue={setActingBodyUnitIds}
                zIndex={4}
                actingBodyId={actingBodyId}
            />
            <EquipmentsDropdown
                value={equipmentFilterList}
                setValue={setEquipmentFilterList}
                actingBodyId={actingBodyId}
                zIndex={3}
            />
            <SkillsDropdown
                value={skillFilterList}
                setValue={setSkillFilterList}
                actingBodyId={actingBodyId}
                zIndex={2}
            />
            <FilterCheckBox
                label={translate('showAllUnits')}
                value={viewAllFilter}
                onChange={(value) => setViewAllFilter(value)}
            />
        </Filters>
    );
}
